module.exports = __webpack_public_path__ + "static/media/classOne.5a6c841c.jpg";